import { useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import FormForgetPassword from "./FormForgetPassword";

import Actions from "../../redux/actions";

const Section = styled.section`
    .form-container {
        margin-right: auto;
        margin-left: auto;

        @media only screen and (max-width: 768px) {
            width: 50%;

        }
        @media only screen and (max-width: 450px) {
            width: 100%;    
        }
        @media only screen and (max-width: 376px) {
            width: 100%;    
        }

        @media only screen and (min-width: 1200px) {
            width: 60%;
        }
    }

`


export default function Index(props) {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(Actions.master.setPath(""))
        dispatch(Actions.popup.toggleVisible(false))

    },[dispatch])
    return(
        <Section className={"section-forget-password"+ (props.className ? props.className : "")}>
            <div className="container" >
                <div className="section-heading">
                    ลืมรหัสผ่าน
                </div>
                <div className="form-container">
                    <FormForgetPassword />
                </div>
            </div>
        </Section>
    )
}